import Icon from './components/Icon';

export default Icon;